import React from "react";
import Cards from "../UI/Cards";
import styles from "./ProjectsMenu.module.css";

const ProjectsMenu = () => {
  return (
    <div className={styles.workCtn}>
      <div className={styles.titleCtn} id="project">
        <h2 className={styles.workTitle}>Projects</h2>
        <h3 className={styles.workDesc}>
          Here are some of my personal projects.
        </h3>
      </div>
      <div className={styles.workItemCtn}>
        <Cards
          title="KickCoin"
          desc="App made for creating campaigns aimed to kickstars with NextJS and Solidity"
          img="https://res.cloudinary.com/dcegpqqjc/image/upload/v1646839000/Screen_Shot_2022-03-09_at_12.16.35_v4zcee.png"
          website="https://kickstarcoin.vercel.app/"
        />
      </div>
      <div className={styles.workItemCtn}>
        <Cards
          title="Travel App"
          desc="MERN project. The purpose of the app is to share different travelling places to different users."
          img="https://res.cloudinary.com/dcegpqqjc/image/upload/v1641916941/Screen_Shot_2022-01-11_at_13.01.40_oakmcz.png"
          website="https://mern-project-9ea6b.web.app/auth"
        />

      </div>
      <div className={styles.workItemCtn}>
        <Cards
          title="SuperHeroe App"
          desc="Challenge was to develop an app with authentication, create a SuperHeroe team (with certain validations) and responsiveness. App should be clone from github."
          img="https://res.cloudinary.com/dcegpqqjc/image/upload/v1641905237/Screen_Shot_2022-01-11_at_09.46.02_uxhfss.png"
          website="https://github.com/malks14/Alkemy-React"
        />
      </div>
      <div className={styles.workItemCtn}>
        <Cards
          title="Food App"
          desc="Food App using React (Context). Basic backend logic applied (Firebase)."
          img="https://res.cloudinary.com/dfjpoucxs/image/upload/v1637505615/Suca/Screen_Shot_2021-11-21_at_11.40.08_wi2fh6.png"
          website="https://dreamy-nightingale-05d3b0.netlify.app/"
        />
      </div>
      <div className={styles.workItemCtn}>
        <Cards
          title="Redux App"
          desc="First project using React Redux."
          img="https://res.cloudinary.com/dfjpoucxs/image/upload/v1637505650/Suca/Screen_Shot_2021-11-21_at_11.40.45_xjoolt.png"
          website="https://xenodochial-aryabhata-323f06.netlify.app/"
        />
      </div>
      <div className={styles.workItemCtn}>
        <Cards
          title="Spotify Clone App"
          desc="Spotify Clone App made with React, Spotify API and API Context and basic Spotify Login."
          img="https://res.cloudinary.com/dcegpqqjc/image/upload/v1641904798/Screen_Shot_2021-11-17_at_16.39.52_jxqlkz.png"
          website="https://spotify-clone-app-6e6bd.web.app/"
        />
      </div>
    </div>
  );
};

export default ProjectsMenu;
